/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/unified-common';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  onKeepChat: () => void;
};

const styles = {
  actionsContainer: css`
    display: flex;
    gap: var(--cds-spacing-150);
  `,
};

const CloseCoachChatConfirmationDialog = ({ open, onClose, onKeepChat }: DialogProps) => {
  const { HeadingGroup, Content, Actions } = Dialog;

  return (
    <Dialog
      aria-describedby="close-chat-confirmation-dialog-content"
      open={open}
      variant="standard"
      width="medium"
      onClose={onKeepChat}
    >
      <HeadingGroup>{_t('Want to keep this chat?')}</HeadingGroup>

      <Content id="close-chat-confirmation-dialog-content">
        <Typography2 component="p" variant="bodyPrimary">
          {_t('If you close the chat, your recommendations and chat history will be lost.')}
        </Typography2>
      </Content>

      <Actions css={styles.actionsContainer}>
        <Button size="medium" variant="primary" onClick={onKeepChat}>
          {_t('Keep chat while I browse')}
        </Button>
        <Button size="medium" variant="secondary" onClick={onClose}>
          {_t('Close chat')}
        </Button>
      </Actions>
    </Dialog>
  );
};

export default CloseCoachChatConfirmationDialog;
